import {FilterItem} from '@framework/types';
import {API_ENDPOINTS} from '@framework/utils/api-endpoints';
import {useQuery} from '@tanstack/react-query';

export const fetchManufacturersFilter = async () => {
    // const {data} = await http.get(API_ENDPOINTS.MANUFACTURERS_FILTER);

    const data: FilterItem[] = [
        {
            "id": 357,
            "label_de": "Osem",
            "label_en": "Osem",
            "label_fr": "Osem",
            "label_he": "Osem",
            "slug": "357",
            "children": []
        },
        {
            "id": 291,
            "label_de": "Achva",
            "label_en": "Achva",
            "label_fr": "Achva",
            "label_he": "Achva",
            "slug": "291",
            "children": []
        },
        {
            "id": 379,
            "label_de": "Elite",
            "label_en": "Elite",
            "label_fr": "Elite",
            "label_he": "Elite",
            "slug": "379",
            "children": []
        },
        {
            "id": 362,
            "label_de": "Pri Chen",
            "label_en": "Pri Chen",
            "label_fr": "Pri Chen",
            "label_he": "Pri Chen",
            "slug": "362",
            "children": []
        },
        {
            "id": 1781,
            "label_de": "Kvuzat Yavne/ Bnei Darom",
            "label_en": "Kvuzat Yavne/ Bnei Darom",
            "label_fr": "Kvuzat Yavne/ Bnei Darom",
            "label_he": "Kvuzat Yavne/ Bnei Darom",
            "slug": "1781",
            "children": []
        },
        {
            "id": 262,
            "label_de": "Vita / Pri Ha'Galil",
            "label_en": "Vita / Pri Ha'Galil",
            "label_fr": "Vita / Pri Ha'Galil",
            "label_he": "Vita / Pri Ha'Galil",
            "slug": "262",
            "children": []
        },
        {
            "id": 352,
            "label_de": "Maya",
            "label_en": "Maya",
            "label_fr": "Maya",
            "label_he": "Maya",
            "slug": "352",
            "children": []
        },
        {
            "id": 1871,
            "label_de": "Ariel/ Shahaf",
            "label_en": "Ariel/ Shahaf",
            "label_fr": "Ariel/ Shahaf",
            "label_he": "Ariel/ Shahaf",
            "slug": "1871",
            "children": []
        },
        {
            "id": 331,
            "label_de": "Hamin Ve'Taim",
            "label_en": "Hamin Ve'Taim",
            "label_fr": "Hamin Ve'Taim",
            "label_he": "Hamin Ve'Taim",
            "slug": "331",
            "children": []
        },
        {
            "id": 273,
            "label_de": "Poliva",
            "label_en": "Poliva",
            "label_fr": "Poliva",
            "label_he": "Poliva",
            "slug": "273",
            "children": []
        },
        {
            "id": 1823,
            "label_de": "Mizrach & Maarav",
            "label_en": "Mizrach & Maarav",
            "label_fr": "Mizrach & Maarav",
            "label_he": "Mizrach & Maarav",
            "slug": "1823",
            "children": []
        },
        {
            "id": 277,
            "label_de": "BarMan",
            "label_en": "BarMan",
            "label_fr": "BarMan",
            "label_he": "BarMan",
            "slug": "277",
            "children": []
        },
        {
            "id": 2155,
            "label_de": "Amstelvelder",
            "label_en": "Amstelvelder",
            "label_fr": "Amstelvelder",
            "label_he": "Amstelvelder",
            "slug": "2155",
            "children": []
        },
        {
            "id": 349,
            "label_de": "Makabi",
            "label_en": "Makabi",
            "label_fr": "Makabi",
            "label_he": "Makabi",
            "slug": "349",
            "children": []
        },
        {
            "id": 2183,
            "label_de": "Gustofino",
            "label_en": "Gustofino",
            "label_fr": "Gustofino",
            "label_he": "Gustofino",
            "slug": "2183",
            "children": []
        },
        {
            "id": 318,
            "label_de": "Elisha",
            "label_en": "Elisha",
            "label_fr": "Elisha",
            "label_he": "Elisha",
            "slug": "318",
            "children": []
        },
        {
            "id": 1826,
            "label_de": "Meshubach",
            "label_en": "Meshubach",
            "label_fr": "Meshubach",
            "label_he": "Meshubach",
            "slug": "1826",
            "children": []
        },
        {
            "id": 393,
            "label_de": "Wissotzky",
            "label_en": "Wissotzky",
            "label_fr": "Wissotzky",
            "label_he": "Wissotzky",
            "slug": "393",
            "children": []
        },
        {
            "id": 298,
            "label_de": "Barkan",
            "label_en": "Barkan",
            "label_fr": "Barkan",
            "label_he": "Barkan",
            "slug": "298",
            "children": []
        },
        {
            "id": 328,
            "label_de": "Golan Heights Winery",
            "label_en": "Golan Heights Winery",
            "label_fr": "Golan Heights Winery",
            "label_he": "Golan Heights Winery",
            "slug": "328",
            "children": []
        },
        {
            "id": 255,
            "label_de": "Recanati",
            "label_en": "Recanati",
            "label_fr": "Recanati",
            "label_he": "Recanati",
            "slug": "255",
            "children": []
        },
        {
            "id": 259,
            "label_de": "Teperberg",
            "label_en": "Teperberg",
            "label_fr": "Teperberg",
            "label_he": "Teperberg",
            "slug": "259",
            "children": []
        },
        {
            "id": 350,
            "label_de": "Manischewitz",
            "label_en": "Manischewitz",
            "label_fr": "Manischewitz",
            "label_he": "Manischewitz",
            "slug": "350",
            "children": []
        },
        {
            "id": 359,
            "label_de": "Paskesz",
            "label_en": "Paskesz",
            "label_fr": "Paskesz",
            "label_he": "Paskesz",
            "slug": "359-2027-358",
            "children": []
        },
        {
            "id": 374,
            "label_de": "Schmerling",
            "label_en": "Schmerling",
            "label_fr": "Schmerling",
            "label_he": "Schmerling",
            "slug": "374",
            "children": []
        },
        {
            "id": 353,
            "label_de": "Menora",
            "label_en": "Menora",
            "label_fr": "Menora",
            "label_he": "Menora",
            "slug": "353",
            "children": []
        }
    ]

    return data as FilterItem[];
};
export const useFetchManufacturersFilter = () => {
    return useQuery<FilterItem[], Error>({
        queryKey: [API_ENDPOINTS.MANUFACTURERS_FILTER],
        queryFn: fetchManufacturersFilter,
    });
};
